export { default as Img200 } from './processed/200/Justice-League.jpg';
export { default as Img400 } from './processed/400/Justice-League.jpg';
export { default as Imgthumb } from './processed/thumb/Justice-League.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Justice-League.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Justice-League.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      48,
      163,
      222
    ],
    "_population": 18,
    "_hsl": [
      0.5565134099616859,
      0.725,
      0.5294117647058824
    ]
  },
  "LightVibrant": {
    "_rgb": [
      227,
      178,
      145
    ],
    "_population": 325,
    "_hsl": [
      0.06707317073170731,
      0.5942028985507245,
      0.7294117647058823
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      118,
      19,
      22
    ],
    "_population": 469,
    "_hsl": [
      0.9949494949494949,
      0.7226277372262774,
      0.26862745098039215
    ]
  },
  "Muted": {
    "_rgb": [
      91,
      133,
      168
    ],
    "_population": 1519,
    "_hsl": [
      0.5757575757575758,
      0.3067729083665338,
      0.5078431372549019
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      195,
      203
    ],
    "_population": 1697,
    "_hsl": [
      0.588888888888889,
      0.12605042016806697,
      0.7666666666666666
    ]
  },
  "DarkMuted": {
    "_rgb": [
      45,
      72,
      84
    ],
    "_population": 1469,
    "_hsl": [
      0.5512820512820512,
      0.3023255813953488,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Justice-League.js